var barba = require('@barba/core');
var css = require('@barba/css');
import mixitup from 'mixitup'; // loaded from node_modules
import mixitupMultifilter from '../scripts/mixitup-multifilter.js'; // loaded from a directory of your choice within your project





var m_pos_x, m_pos_y;

window.onmousemove = function(e) {
  m_pos_x = e.pageX;
  m_pos_y = e.pageY;
}

setInterval(function() {
  var newthing = document.createElement('div');
  newthing.classList.add('plant');

  var rndmClass = ['plant_1', 'plant_2', 'plant_3', 'plant_4', 'plant_5', 'plant_6', 'plant_7'];
  var rng = Math.floor(Math.random() * rndmClass.length);
  newthing.classList.add(rndmClass[rng]);

  document.body.appendChild(newthing);


  
  





  newthing.style.position = "fixed";
  newthing.style.left = m_pos_x + "px";
  newthing.style.top = m_pos_y + "px";
}, 1000);

document.addEventListener("mouseleave", function(event){

  if(event.clientY <= 0 || event.clientX <= 0 || (event.clientX >= window.innerWidth || event.clientY >= window.innerHeight))
  {

    var plants = document.querySelectorAll('.plant');
    for (const plant of plants) {
      plant.remove();
      };
    
    
  }
});



window.addEventListener('load', function(event) {


  var rndmClass_home = [ 'issue-1-logo', 'issue-2-logo', 'issue-3-logo', 'issue-4-logo', 'issue-5-logo', 'issue-6-logo', 'issue-7-logo' ];
  var rng_home = Math.floor(Math.random() * rndmClass_home.length);
  document.querySelector('.logo').classList.add(rndmClass_home[rng_home]);   
   


    if ( document.querySelector('.searcher') != null) {
var target = document.querySelector(".issue__thumb__one");
target.addEventListener("mouseover", mOver, false);
target.addEventListener("mouseout", mOut, false);

function mOver() {
   document.querySelector('.searcher').classList.add('green');
}

function mOut() {  
  document.querySelector('.searcher').classList.remove('green');
}


var target2 = document.querySelector(".issue__thumb__two");
target2.addEventListener("mouseover", mOver2, false);
target2.addEventListener("mouseout", mOut2, false);

function mOver2() {
  document.querySelector('.searcher').classList.add('orange');
}

function mOut2() {  
  document.querySelector('.searcher').classList.remove('orange');
}
    }
});












/*!
 * Emoji Cursor.js
 * - 90's cursors collection
 * -- https://github.com/tholman/90s-cursor-effects
 * -- https://codepen.io/tholman/full/rxJpdQ
 */


/*
(function emojiCursor() {
  
  var possibleEmoji = ["🌼", "🌸","🌺"]
  var width = window.innerWidth;
  var height = window.innerHeight;
  var cursor = {x: width/2, y: width/2};
  var particles = [];
  
  function init() {
    bindEvents();
    loop();
  }
  
  function bindEvents() {
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('touchmove', onTouchMove);
    document.addEventListener('touchstart', onTouchMove);
    
    window.addEventListener('resize', onWindowResize);
  }
  
  function onWindowResize(e) {
    width = window.innerWidth;
    height = window.innerHeight;
  }
  
  function onTouchMove(e) {
    if( e.touches.length > 0 ) {
      for( var i = 0; i < e.touches.length; i++ ) {
        addParticle( e.touches[i].clientX, e.touches[i].clientY, possibleEmoji[Math.floor(Math.random()*possibleEmoji.length)]);
      }
    }
  }
  
  function onMouseMove(e) {    
    cursor.x = e.clientX;
    cursor.y = e.clientY;
    
    addParticle( cursor.x, cursor.y, possibleEmoji[Math.floor(Math.random()*possibleEmoji.length)]);
  }
  
  function addParticle(x, y, character) {
    var particle = new Particle();
    particle.init(x, y, character);
    particles.push(particle);
  }
  
  function updateParticles() {
    

    for( var i = 0; i < particles.length; i++ ) {
      particles[i].update();
    }
    

    for( var i = particles.length -1; i >= 0; i-- ) {
      if( particles[i].lifeSpan < 0 ) {
        particles[i].die();
        particles.splice(i, 1);
      }
    }
    
  }
  
  function loop() {
    requestAnimationFrame(loop);
    updateParticles();
  }
  

  
  function Particle() {

    this.lifeSpan = 120; //ms
    this.initialStyles ={
      "position": "absolute",
      "display": "block",
      "pointerEvents": "none",
      "z-index": "-1",
      "fontSize": "30px",
      "will-change": "transform",
      "filter": "grayscale(1)",
      "pointerEvents": "none"
    };


    this.init = function(x, y, character) {

      this.velocity = {
        x:  (Math.random() < 0.5 ? -1 : 1) * (Math.random() / 2),
        y: 1
      };
      
      this.position = {x: x - 10, y: y - 20};

      this.element = document.createElement('span');
      this.element.innerHTML = character;
      applyProperties(this.element, this.initialStyles);
      this.update();
      
      document.body.appendChild(this.element);
    };
    
    this.update = function() {
      this.position.x += this.velocity.x;
      this.position.y += this.velocity.y;
      this.lifeSpan--;
      
      this.element.style.transform = "translate3d(" + this.position.x + "px," + this.position.y + "px,0) scale(" + (this.lifeSpan / 120) + ")";
    }
    
    this.die = function() {
      this.element.parentNode.removeChild(this.element);
    }
    
  }
  
  function applyProperties( target, properties ) {
    for( var key in properties ) {
      target.style[ key ] = properties[ key ];
    }
  }
  
  init();
})();
*/


  // Call the mixitup factory's .use() method, passing in the extension to install it
  if ( document.querySelector('.searcher') != null) {




    mixitup.use(mixitupMultifilter);
  
  
    var containerEl = document.querySelector('.searcher');
    var targetSelector = '.mix';
    var activeHash = '';
  

    
  
  
  
  
    /**
     * Deserializes a hash segment (if present) into in an object.
     *
     * @return {object|null}
     */
  
    function deserializeHash() {
      var hash = window.location.hash.replace(/^#/g, '');
      var obj = null;
      var groups = [];
  
      if (!hash) return obj;
  
      obj = {};
      groups = hash.split('&');
  
      groups.forEach(function (group) {
        var pair = group.split('=');
        var groupName = pair[0];
  
        obj[groupName] = pair[1].split(',');
      });
  
      return obj;
  
    }


  
  
    /**
     * Serializes a groupsState object into a string.
     *
     * @param   {object}    groupsState
     * @return  {string}
     */
  
    function serializeGroupsState(groupsState) {
      var output = '';
  
      for (var key in groupsState) {
        var values = groupsState[key];
  
        if (!values.length) continue;
  
        output += key + '=';
        output += values.join(',');
        output += '&';
      }
      ;
  
      output = output.replace(/&$/g, '');
  
      return output;
    }
  
    /**
     * Constructs a `groupsState` hash object using the
     * `getFilterGroupSelectors()` API method.
     *
     * @return {object}
     */
  
    function getGroupsState() {


      
      // NB: You will need to rename the object keys to match the names of
      // your project's filter groups – these should match those defined
      // in your HTML.
  
      var groupsState = {
        issue: mixer.getFilterGroupSelectors('issue').map(getValueFromSelector),
  
      };
      return groupsState;
    }
  
    /**
     * Updates the URL hash whenever the current filter changes.
     *
     * @param   {mixitup.State} state
     * @return  {void}
     */
  
    function setHash(state) {

    
      setTimeout(function () {
      if(window.location.hash) {

        document.querySelector('.print-button').classList.add('active');
          } else {
            document.querySelector('.print-button').classList.remove('active');
          }
        }, 100);
  
      const titles = document.querySelectorAll('.letter__block__letter');

Array.from(titles).forEach(li => {
  const items = [];
  let next = li.nextElementSibling;

  while (next && next.matches('.mix')) {
    items.push(next);
    next = next.nextElementSibling;
  }

  const hide = items.every(n => n.style.display === 'none')

  if (hide) {
    li.style.display = 'none';
  } else {
    li.style.removeProperty('display')
  }


})
  
      var selector = state.activeFilter.selector;
  
      // Construct an object representing the current state of each
      // filter group
  
      var groupsState = getGroupsState();
  
      // Create a URL hash string by serializing the groupsState object
  
      var newHash = '#' + serializeGroupsState(groupsState);
  
      if (selector === targetSelector && window.location.hash) {
        // Equivalent to filter "all", remove the hash
  
        activeHash = '';
  
        history.pushState(null, document.title, window.location.pathname); // or `history.replaceState()`
      } else if (newHash !== window.location.hash && selector !== targetSelector) {
        // Change the hash
  
        activeHash = newHash;
  
        history.pushState(null, document.title, window.location.pathname + newHash); // or `history.replaceState()`
      }
    }
  
    /**
     * Filters the mixer and updates the multifilter UI using a provided
     * groupsState object.
     *
     * @param  {object|null}    groupsState
     * @param  {boolean}        [animate]
     * @return {Promise}
     */
  
    function filterMixerByGroupsState(groupsState, animate) {
      var issue = (groupsState && groupsState.issue) ? groupsState.issue : [];

  
  
      mixer.setFilterGroupSelectors('issue', issue.map(getSelectorFromValue));
  
      // Parse the filter groups (passing `false` will perform no animation)
  
      return mixer.parseFilterGroups(animate ? true : false);
    }
  
    /**
     * Converts a selector (e.g. '.green') into a simple value (e.g. 'green').
     *
     * @param   {string} selector
     * @return  {string}
     */
  
    function getValueFromSelector(selector) {
      return selector.replace(/^./, '');
    }
  
    /**
     * Converts a simple value (e.g. 'green') into a selector (e.g. '.green').
     *
     * @param   {string} selector
     * @return  {string}
     */
  
    function getSelectorFromValue(value) {
      return '.' + value;
    }
  
    var groupsState = deserializeHash();
  
  // Instantiate MixItUp
  
    var mixer = mixitup(containerEl, {
      multifilter: {
        enable: true
      },
      animation: {
       // effects: 'fade',
       // reverseOut: true,
      //  nudge: false // Disable nudging to create a carousel-like effect
      enable: false
      },
      callbacks: {
        onMixEnd: setHash // Call the setHash() method at the end of each operation
      }
    });

  
    if (groupsState) {
      // If a valid groupsState object is present on page load, filter the mixer
  
      filterMixerByGroupsState(groupsState);
    }
  
  // Add an "onhashchange" handler to keep the mixer in sync as the user goes
  // back and forward through their history.
  
  // NB: This may or may not be the desired behavior for your project. If you don't
  // want MixItUp operations to count as individual history items, simply use
  // `history.replaceState()` instead of `history.pushState()` within the `setHash()`
  // function above. In which case this handler would no longer be neccessary.
  
  
    window.onhashchange = function () {
      var groupsState = deserializeHash();
      var hash = window.location.hash;
  
  
      // Compare new hash with active hash
  
      if (hash === activeHash) return; // no change
  
      activeHash = hash;
  
      filterMixerByGroupsState(groupsState, true);
    };
  };



























function all() {


  if ( document.querySelector('#ship-to-different-address-checkbox') != null) {
    const box = document.querySelector('.woocommerce-shipping-fields__field-wrapper');
    const checkbox = document.getElementById('ship-to-different-address-checkbox');
    box.style.display = 'none';

  
  checkbox.addEventListener('click', function handleClick() {
    if (checkbox.checked) {
      box.style.display = 'block';
    } else {
      box.style.display = 'none';
    }
  });
};

}












all();







barba.use(css);
barba.init({
  preventRunning: true,
  timeout: 200000,


  transitions: [

    {

      beforeLeave: function (data) {

      },

      beforeEnter: function (data) {



  

    

        all();


  



      },
      afterEnter: function (data) {



      },


      leave: function (data) {
      },
      enter: function (data) {
      },
    },
  ],
});












barba.hooks.afterLeave((data) => {




  const remove_after = data.next.html.indexOf('" id="body"'),
  result =  data.next.html.substring(0, remove_after),
  result_2 = result.substring(result.indexOf("<body class=") + 13);

  document.body.setAttribute("class", result_2);

  if (!match || !match[1]) {
    // If no body class, remove it
    document.body.setAttribute("class", "");
  } else {
    // Set the new body class
    document.body.setAttribute("class", result);
  }
});


barba.hooks.afterEnter((data) => {
  if (window.innerWidth > 768) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    }
    else {
      if ( document.querySelector('.home') == null) {
      setTimeout(function () {
      document.querySelector('.container').scrollIntoView({ 
        behavior: 'smooth'
      });
    }, 700); // prints "zero,one,two" after 2 seconds
  }
    }
});





barba.hooks.enter(() => {

});




